import * as types from '../actions/actionTypes';
import initialState from "./initialState";

export function updateMyQuickSchedulesArrayReducer(
  state = initialState.myQuickSchedules, action
  ) {
  switch(action.type) {
    case types.UPDATE_MY_QUICK_SCHEDULES_ARRAY:
      return action.myQuickSchedulesArray;
    default:
      return state;
  }
}

export function listMyQuickSchedulesReducer(
  state = initialState.listMyQuickSchedules, action
  ) {
  switch(action.type) {
    case types.FETCH_LIST_MY_QUICK_SCHEDULES_SUCCESS:
      return action.listMyQuickSchedules;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/myQuickScheduleReducer.js